import Link from 'next/link'

import { PopularProductsCarousel } from '@/features/popular-products'

import cl from './empty-basket-content.module.scss'

export const EmptyBasketContent = () => {
	return (
		<section className={cl.root}>
			<h1 className={cl.title}>Корзина пуста</h1>
			<p className={cl.subtitle}>
				Воспользуйтесь поиском, чтобы найти всё, что нужно, или выберите что-нибудь из
				<Link prefetch={false} href="/catalog">
					{' '}
					каталога
				</Link>
			</p>
			<div className={cl.recommended__products}>
				<PopularProductsCarousel title="Рекомендуемые товары" />
			</div>
		</section>
	)
}
